import React from 'react'
import PropTypes from 'prop-types'
import BottomNavigation from '@material-ui/core/BottomNavigation'
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Paper from '@material-ui/core/Paper'
import LocalActivity from '@material-ui/icons/LocalActivity'
import History from '@material-ui/icons/History'
import { PASS_VIEWS } from '../util/constants'
import { withStyles } from '@material-ui/core/styles'
const styles = theme => ({

})
const PassViewMenu = ({ value, onChange }) => {
  return (
    <Paper>
      <BottomNavigation value={value} onChange={onChange} >
        <BottomNavigationAction label="Active" value={PASS_VIEWS.ACTIVE} icon={<LocalActivity />} />
        <BottomNavigationAction label="History" value={PASS_VIEWS.HISTORY} icon={<History />} />
      </BottomNavigation>
    </Paper>
  );
}

PassViewMenu.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}
export default withStyles(styles)(PassViewMenu)


// WEBPACK FOOTER //
// ./src/components/pass-view-menu.js